import { NewContactDialog } from "@jugl-web/domain-resources/contacts/components/NewContactDialog";
import {
  TicketDetailItem,
  TicketDetailItemPlaceholder,
  TicketDetailItemText,
} from "@jugl-web/domain-resources/tickets/components/TicketDetailItem";
import { ClientContact } from "@jugl-web/rest-api";
import { TicketContact } from "@jugl-web/rest-api/tickets/models/common-types";
import { Avatar } from "@jugl-web/ui-kit";
import { TicketContactPickerPopover } from "@web-src/modules/client-support/components/TicketContactPickerPopover/TicketContactPickerPopover";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { FC, useState } from "react";

interface ContactDetailItemProps {
  contact: TicketContact | null;
  errorMessage?: string;
  onChange: (contact: TicketContact) => void;
}

export const ContactDetailItem: FC<ContactDetailItemProps> = ({
  contact,
  errorMessage,
  onChange,
}) => {
  const { entityId } = useEntitySelectedProvider();

  const [isNewContactDialogOpen, setIsNewContactDialogOpen] = useState(false);

  const handleContactCreated = (createdContact: ClientContact) => {
    onChange({
      id: createdContact.id,
      name: createdContact.name ?? "Unknown",
    });
  };

  return (
    <>
      <TicketContactPickerPopover
        contact={contact}
        onChange={onChange}
        onNewContactSelect={() => setIsNewContactDialogOpen(true)}
        renderTrigger={({ Trigger, triggerRef, isOpen }) => (
          <Trigger
            as={TicketDetailItem}
            ref={triggerRef}
            isInteractive
            isActive={isOpen}
            errorMessage={errorMessage}
            label="Customer"
            content={
              contact ? (
                <TicketDetailItemText
                  startSlot={
                    <Avatar size="sm" imageUrl={null} username={contact.name} />
                  }
                  text={contact.name}
                />
              ) : (
                <TicketDetailItemPlaceholder />
              )
            }
          />
        )}
      />
      <NewContactDialog
        entityId={entityId}
        isOpen={isNewContactDialogOpen}
        onRequestClose={() => setIsNewContactDialogOpen(false)}
        onContactCreated={handleContactCreated}
      />
    </>
  );
};
